import сustomPageScroll from '../components/custom-scroll';

export default (x, y, duration = 1200, callback = () => {}) => {
	сustomPageScroll.scroller.scrollTo(x, y, duration, {
		callback: () => {
			callback();
		},
		//  add custom easing, error
		// easing: easing.easeOutBack,
	});
}
